export default __webpack_public_path__ + "static/otpImg-eb6bd0352e50459402fe4a7095f0bbad.jpg";